export default __webpack_public_path__ + "static/media/568.42b2bae3.png";